export default [
	// {
	// 	key: "id",
	// 	label: "#",
	// 	visible: true,
	// 	thClass: "text-center",
	// },
	{
		key: "id",
		label: "Sub categoria",
		visible: true,
		thClass: "text-center",
	},
	{
		key: "category",
		label: "Categoria",
		visible: true,
		thClass: "text-center",
		tdClass: "text-center",
	},

	{
		key: "created_by",
		label: "Creado por",
		visible: true,
		thClass: "text-center",
	},
	// {
	// 	key: "created_at",
	// 	label: "Creado por",
	// 	visible: true,
	// 	thClass: "text-center",
	// },
	{
		key: "actions",
		label: "Acciones",
		thClass: "text-center",
		visible: true,
	},
]
